import { render, staticRenderFns } from "./CustomerOilStorage.vue?vue&type=template&id=59936c92&scoped=true"
import script from "./CustomerOilStorage.vue?vue&type=script&lang=js"
export * from "./CustomerOilStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59936c92",
  null
  
)

export default component.exports